$bog_merchquarium_button $mol_button_major
	hidden false
